import { useState } from 'react';
import { 
  Container, 
  Row, 
  Col, 
  Card, 
  CardBody, 
  CardHeader, 
  Form, 
  FormGroup, 
  Label, 
  Input
} from "reactstrap";
import MainLayout from "../../layouts/MainLayout";
import { toast } from 'react-toastify';
import DefaultButton from '../../components/Buttons/Default';
import { API_URL } from '../../utils/constants';
import { useTranslation } from 'react-i18next';

function ContactUsPage() {
  const { t } = useTranslation();
  const [storeLoading, setStoreLoading] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone_number: '',
    subject: '',
    message: ''
  });

  const subjectOptions = [
    { value: '', label: t('contact.subject_options.select') },
    { value: 'general', label: t('contact.subject_options.general') },
    { value: 'support', label: t('contact.subject_options.technical') },
    { value: 'business', label: t('contact.subject_options.deal') },
    { value: 'feedback', label: t('contact.subject_options.note') },
    { value: 'delete_acount', label: t('contact.subject_options.delete_account') },
    { value: 'delete_data', label: t('contact.subject_options.delete_data') },
    { value: 'other', label: t('contact.subject_options.other') }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStoreLoading(true);
    
    // Basic validation
    if (!formData.fullName || !formData.email || !formData.subject || !formData.message) {
      toast.error('يرجى ملئ جميع المعلومات.');
      setStoreLoading(false);
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error('يرجى إدخال عنوان بريد إلكتروني صالح.');
      setStoreLoading(false);
      return;
    }

    fetch(API_URL+'/contact-us/store', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        fullname: formData.fullName,
        email: formData.email,
        phone_number: formData.phone_number,
        subject: formData.subject,
        message: formData.message
      })
    })
    .then(response => response.json())
    .then(data => {
      setStoreLoading(false);
      if (data.success) {
        toast.success('تم ارسال الرسالة بنجاح');
        // Reset form
        setFormData({
          fullName: '',
          email: '',
          subject: '',
          message: ''
        });
      } else {
        toast.error(data.message || 'حدث خطأ أثناء ارسال الرسالة');
      }
    })
    .catch(error => {
      setStoreLoading(false);
      toast.error('حدث خطأ أثناء ارسال الرسالة');
    });
  };

  return (
    <MainLayout>
      <section className="py-5 bg-light">
        <Container>
          <Row className="justify-content-center">
            <Col lg="8" md="10">
              <div className="text-center mb-5">
                <p className="lead text-muted">
                  {t('contact.subtitle')}
                </p>
              </div>
              
              <Card className="border-0">
                <CardHeader className="bg-primary text-white">
                  <h3 className="mb-0">{t('contact.title')}</h3>
                </CardHeader>
                <CardBody className="p-4">
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md="6">
                        <FormGroup>
                          <Label for="fullName" className="font-weight-bold">
                            {t('contact.fullname')} <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            name="fullName"
                            id="fullName"
                            placeholder={t('contact.fullname_placeholder')}
                            value={formData.fullName}
                            onChange={handleInputChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <Label for="email" className="font-weight-bold">
                            {t('contact.email')} <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="email"
                            name="email"
                            id="email"
                            placeholder={t('contact.email_placeholder')}
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <FormGroup>
                      <Label for="phone_number" className="font-weight-bold">
                        {t('contact.phone_number')} <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        name="phone_number"
                        id="phone_number"
                        placeholder={t('contact.phone_number_placeholder')}
                        value={formData.phone_number}
                        onChange={handleInputChange}
                        required
                      />
                    </FormGroup>
                    
                    <FormGroup>
                      <Label for="subject" className="font-weight-bold">
                        {t('contact.subject')} <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="select"
                        name="subject"
                        id="subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                        required
                      >
                        {subjectOptions.map(option => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                    
                    <FormGroup>
                      <Label for="message" className="font-weight-bold">
                        {t('contact.message')} <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="textarea"
                        name="message"
                        id="message"
                        rows="6"
                        placeholder="اكتب رسالتك هنا..."
                        value={formData.message}
                        onChange={handleInputChange}
                        required
                      />
                    </FormGroup>
                    
                    <div className="text-center mt-4">
                      <DefaultButton 
                        type="submit" 
                        disabled={storeLoading || !formData.fullName || !formData.email || !formData.subject || !formData.message}
                        loading={storeLoading}
                      >
                        {t('contact.button')}
                      </DefaultButton>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </MainLayout>
  );
}

export default ContactUsPage;